import { v4 as uuidv4 } from 'uuid';

const SESSION_KEY = 'chatbot_session_id';

export const getOrCreateSessionId = () => {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = uuidv4();
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
};

export const clearSession = () => {
  sessionStorage.removeItem(SESSION_KEY);
};

export const parseMarkdown = (text = '') =>
  text
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.*?)\*/g, '<em>$1</em>')
    .replace(/\n/g, '<br/>');

export const buildUserMessage = (content) => ({
  id: uuidv4(),
  from: 'user',
  type: 'text',
  content,
  timestamp: new Date(),
});

export const buildBotMessage = (data) => ({
  id: uuidv4(),
  from: 'bot',
  type: data.type,
  content: data.content,
  options: data.options,
  fields: data.fields,
  form_fields: data.form_fields,
  cta: data.cta,
  timestamp: new Date(),
});

export const buildTypingMessage = () => ({
  id: uuidv4(),
  from: 'bot',
  type: 'typing',
  timestamp: new Date(),
});

export const FIELD_STATUS_COLORS = {
  good: { color: '#15803D', background: '#DCFCE7' },
  bad: { color: '#DC2626', background: '#FEE2E2' },
  neutral: { color: '#334155', background: '#F1F5F9' },
};